import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useParams } from "react-router-dom";

import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import {
  checkAcessRights,
  formatToIndianCurrencyWithoutSymbol,
  formatWeight,
} from "../../_helper/helper";
import { PRINT_ACCESS } from "../../_contstants/common";
import { IoMdPrint } from "react-icons/io";
import moment from "moment";
import { LoadingPanel } from "../../components/layout/Loading";
// import { MdOutlineFileDownload } from "react-icons/md";
// import { API_URL } from "../../app/config";
// import { ErrorToast } from "../../components/toast/Toasts";
import { getPalishById } from "./services/palish.services";
import { clearPalishDetail } from "./palishSlice";
import { sumBy } from "lodash";

const PalishIssueVoucherPDF = () => {
  const dispatch = useAppDispatch();
  const param = useParams();
  const palish_guid = param?.palish_guid || "";
  const PalishDetail = useAppSelector((state) => state.palish.PalishDetail);
  const karigarIdWiseOutStandingAmount =
    PalishDetail?.karigarIdWiseOutStandingAmount &&
    PalishDetail?.karigarIdWiseOutStandingAmount?.length > 0
      ? PalishDetail?.karigarIdWiseOutStandingAmount[0]
      : {};
  const loading = useAppSelector((state) => state.palish.loading);
  const isPrintAccess = checkAcessRights("/palish", PRINT_ACCESS);
  const gridRef = useRef<any>(null);
  useEffect(() => {
    return () => {
      dispatch(clearPalishDetail());
    };
  }, []);
  useEffect(() => {
    if (palish_guid) {
      dispatch(getPalishById(palish_guid));
    }
  }, [palish_guid]);

  useEffect(() => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
      @media print {
        @page {
          margin-left: 0.5cm;
          margin-right: 0.5cm;
        }
        .no-print {
          display: none !important;
        }
        .printbuttons {
          display: none !important;
        }
        .issue-order-item-print-break {
          page-break-inside: avoid;
        }
        .container {
          width: 100% !important;
          max-width: 100% !important;
          padding: 0 !important;
          margin: 0 !important;
        }
        body {
          zoom: 70% !important;
        }
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const handlePrint = () => {
    window.print();
  };

/*
  const handleDownloadPdf = async (palish_guid: string, issue_no: any) => {
    try {
      const response = await fetch(
        `${API_URL}/Palish/ FindByIDPalishDownloadPDF`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            palish_guid,
          }),
        },
      );

      if (!response.ok) {
        ErrorToast("Failed to generate PDF! - Please try after some time");
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `palish-Issue-${issue_no || moment().date()}.pdf`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to download PDF! - Please try again later");
    }
  };
*/

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}

      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem>
          <div
            className="printbuttons"
            style={{
              textAlign: "center",
              padding: "20px",
              display: "block",
            }}
          >
            {isPrintAccess && (
              <Button
                type="button"
                style={{
                  marginRight: "10px",
                  padding: "5px 10px",
                  border: "none",
                }}
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={handlePrint}
              >
                <IoMdPrint style={{ fontSize: "20px" }} /> Print Report
              </Button>
            )}
            {/* {isPrintAccess && (
              <Button
                type="button"
                style={{
                  marginRight: "10px",
                  padding: "5px 10px",
                  border: "none",
                }}
                fillMode={"solid"}
                themeColor={"tertiary"}
                onClick={() =>
                  handleDownloadPdf(palish_guid, PalishDetail.palish_no)
                }
              >
                <MdOutlineFileDownload style={{ fontSize: "20px" }} /> Download
              </Button>
            )} */}
          </div>
        </GridLayoutItem>
        <GridLayoutItem>
          <Typography.h5
            style={{
              marginBottom: 0,
              textAlign: "center",
            }}
          >
            PALISH ISSUE VOUCHER
          </Typography.h5>
          <Typography.h6
            style={{
              marginBottom: 15,
              textAlign: "center",
            }}
          >
            ISSUE NO : {PalishDetail?.palish_no} | ISSUE DATE :{" "}
            {moment(PalishDetail?.issue_date).format("DD/MM/YYYY")}
          </Typography.h6>
        </GridLayoutItem>
      </GridLayout>

      <div className="container">
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            flexDirection: "column",
            marginBottom: 10,
          }}
        >
          <div className="card-header bg-light">
            <h5 className="mb-0 fw-bold">Karigar Stock</h5>
          </div>
          <div className="stock-container">
            <div className="stock-item w-100">
              <div className="stock-header">
                <div
                  className={`indicator-dot amount-dot-${karigarIdWiseOutStandingAmount.Amount_credit_debit}`}
                ></div>
                <Typography.h6 className="stock-label">
                  Amount Balance
                </Typography.h6>
              </div>
              <Typography.h6
                className={`stock-value text-nowrap amount-value-${karigarIdWiseOutStandingAmount.Amount_credit_debit}`}
              >
                ₹
                {formatToIndianCurrencyWithoutSymbol(
                  karigarIdWiseOutStandingAmount.amount || 0,
                )}{" "}
                <span
                  style={{
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    fontSize: 16,
                  }}
                >
                  {karigarIdWiseOutStandingAmount.Amount_credit_debit}
                </span>
              </Typography.h6>
            </div>

            <div className="stock-item  w-100">
              <div className="stock-header">
                <div
                  className={`indicator-dot phine-dot-${karigarIdWiseOutStandingAmount.phine_credit_debit}`}
                ></div>
                <Typography.h6 className="stock-label">
                  Phine (gm) Stock
                </Typography.h6>
              </div>
              <Typography.h6
                className={`stock-value phine-value-${karigarIdWiseOutStandingAmount.phine_credit_debit}`}
              >
                {formatWeight(karigarIdWiseOutStandingAmount.phine)}{" "}
                <span
                  style={{
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    fontSize: 16,
                  }}
                >
                  {karigarIdWiseOutStandingAmount.phine_credit_debit}
                </span>
              </Typography.h6>
            </div>
          </div>
        </div>
        {/* Summary Information */}
        <div className="card summary-card mb-4">
          <div className="card-header bg-light">
            <h5 className="mb-0">Order Summary</h5>
          </div>
          <div className=" p-0">
            <table className="table table-bordered mb-0">
              <tbody>
                <tr>
                  <td style={{ width: "50%" }}>
                    <strong>Karigar</strong>
                    <br />
                    <span>{PalishDetail?.karigar_name}</span>
                  </td>
                  <td style={{ width: "50%" }}>
                    <strong>Address</strong>
                    <br />
                    <span>{PalishDetail?.address}</span>
                  </td>
                  {/* <td style={{ width: "25%" }}>
                    <strong>Given Amount</strong>
                    <br />
                    <span className="text-success">
                      {formatToIndianCurrency(PalishDetail?.given_amount || 0)}
                    </span>
                  </td>
                  <td style={{ width: "25%" }}>
                    <strong>Remarks</strong>
                    <br />
                    <span className="text-muted">{PalishDetail?.remarks}</span>
                  </td> */}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {/* Gold Issues */}
        {PalishDetail?.palish_order?.length > 0 && (
          <div className="card gold-card mb-4">
            <div className="card-header bg-light">
              <h5 className="mb-0">Palish Order </h5>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-bordered mb-0">
                  <thead className="table-success">
                    <tr>
                      <th style={{ width: "15%" }}>Order No</th>
                      <th style={{ width: "25%" }}>Product</th>
                      <th style={{ width: "10%" }}>Weight (gm)</th>
                      <th style={{ width: "25%" }}>Product Description</th>
                      <th style={{ width: "25%" }}>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {PalishDetail?.palish_order?.map((item, idx) => {
                      return (
                        <tr key={item?.id || idx}>
                          <td>{item?.order_no}</td>
                          <td>{item?.item_name}</td>
                          <td>{formatWeight(item?.weight)}</td>
                          <td>{item?.item_description}</td>
                          <td>{item?.remarks}</td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td colSpan={2} className="fw-bold">
                        TOTAL
                      </td>
                      <td>
                        {formatWeight(
                          sumBy(PalishDetail?.palish_order, "weight"),
                        )}
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        {/* Ghat Items */}
        {/* <h5 className="mb-2 fw-bold">Order Details</h5>
        {PalishDetail?.ghat_item?.map((item) => {
          return (
            <div className="card items-card issue-order-item-print-break">
              <div
                className="card-header"
                style={{ backgroundColor: "lightsteelblue" }}
              >
                <h5 className="mb-0">Order No : {item?.order_no}</h5>
              </div>
              <div className="card-body p-0">
                <div className="p-1">
                  <div className="card items-card">
                    <div className="card-header bg-light p-1">
                      <h6 className="mb-0 fw-bold">Item Details</h6>
                    </div>
                    <div className="card-body p-0">
                      <table className="table table-bordered mb-0">
                        <tbody>
                          <tr>
                            <td style={{ width: "33.33%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Product</strong>
                              </p>
                              <p className="m-0"> {item?.item_name}</p>
                            </td>
                            <td style={{ width: "33.33%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Size</strong>
                              </p>
                              <p className="m-0">{item?.size}</p>
                            </td>
                            <td style={{ width: "33.33%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Weight</strong>
                              </p>
                              <p className="m-0">{item?.weight}</p>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ width: "33.33%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Color</strong>
                              </p>
                              <p className="m-0">{item?.color}</p>
                            </td>
                            <td style={{ width: "33.33%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Category</strong>
                              </p>
                              <p className="m-0">{item?.category_name}</p>
                            </td>
                            <td style={{ width: "33.33%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Purity</strong>
                              </p>
                              <p className="m-0">{item?.purity}</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {item?.approval_items?.length > 0 && (
                    <div className="card items-card mt-1">
                      <div className="card-header bg-light p-1">
                        <h6 className="mb-0 fw-bold">Approval Items</h6>
                      </div>
                      <div className="card-body p-0">
                        <div className="approval-table">
                          <table className="table table-bordered mb-0 approval-items-table">
                            <thead>
                              <tr>
                                <th style={{ width: "10%" }}>Type</th>
                                <th style={{ width: "25%" }}>Item</th>
                                <th style={{ width: "15%" }}>Weight</th>
                                <th style={{ width: "10%" }}>Qty</th>
                                <th style={{ width: "40%" }}>Remarks</th>
                              </tr>
                            </thead>
                            <tbody>
                              {item?.approval_items?.map((approval_item) => {
                                return (
                                  <tr>
                                    <td>{approval_item?.type}</td>
                                    <td>{approval_item?.item_name}</td>
                                    <td>{approval_item?.weight}</td>
                                    <td>{approval_item?.qty}</td>
                                    <td>{approval_item?.remarks}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })} */}
      </div>
    </>
  );
};

export default PalishIssueVoucherPDF;
